import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Link } from 'react-router-dom'
import Rating from '@mui/material/Rating'
// import htmlcss from '../Image/htmlcss.jpg'
import Php from '../Image/Php.jpg'
import Java from '../Image/Java.jpg'
// import Python from '../Image/Python.jpg'
// import Net from '../Image/Net.jpg'
import htmlcss from '../Image/htmlcss.webp'
// import Php from '../Image/Php.webp'
// import Java from '../Image/Java.webp'
import Python from '../Image/Python.webp'
import Net from '../Image/Net.webp'
import { BsArrowUpRight } from 'react-icons/bs'
import { FiArrowRightCircle } from 'react-icons/fi'

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  }
}

export default function VerticalTabs() {
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const courses = [
    {
      title: 'HTML/CSS',
      description:
        'Get started on an exciting new adventure in AI with our all-encompassing training program. This course will...',
      imageUrl: htmlcss,
      rating: 4,
      link: '/Html-CSS',
      alt: 'Html-CSS',
      rating: 4.5,
    },
    {
      title: 'PHP Course',
      description:
        'With our in-depth course covering key ideas, network history, operating system fundamentals, and ethical...',
      imageUrl: Php,
      rating: 4,
      link: '/PHP-Course',
      alt: 'PHP-Course',
      rating: 4.5,
    },
    {
      title: 'Java Course',
      description:
        'In-depth study of Human Resource Management (HRM) will be provided in this course. Examine all aspects of HR, including performance...',
      imageUrl: Java,
      rating: 4,
      link: '/Java-Coding-Camp-Course',
      alt: 'Java-Coding-Camp-Course',
      rating: 4.5,
    },
    {
      title: 'Python Course',
      description:
        'Take a deep dive into the exciting world of marketing management and digital marketing. This course covers everything from comprehending...',
      imageUrl: Python,
      rating: 4,
      link: '/Python-Coding-Camp-Course',
      alt: 'Python-Coding-Camp-Course',
      rating: 4.5,
    },
    {
      title: '.Net Course',
      description:
        'VLSI technology has revolutionized the electronics industry by enabling the development of increasingly complex and powerful integrated...',
      imageUrl: Net,
      rating: 4,
      link: '/.Net-Coding-Camp-Course',
      alt: '.Net-Coding-Camp-Course',
      rating: 4.5,
    },
  ]

  const CourseWindow = ({ course, index }) => (
    <div className="container">
      <div className="" key={course.title}>
        <Link className="Program_card_link" to={course.link}>
          <div className="row border shadow-sm Program_card pb-1">
            <div className="p-3 col-4">
              <img
                className="border rounded"
                src={course.imageUrl}
                alt={course.title}
              />
            </div>
            <div className="px-3 col-8">
              <h1 className="pt-4">{course.title}</h1>
              <p className="pt-1">{course.description}</p>
              <h6>
                <b>Duration:</b> 6 Week
              </h6>
              <h6>
                <b>Click Here to View Program Details</b>
              </h6>
              <div className="row">
                <div className="col-10">
                  <h5 className="fw-normal pt-2">
                    {course.rating}{' '}
                    <Rating
                      name={`rating-${index}`}
                      size="small"
                      defaultValue={course.rating}
                      precision={0.1}
                      readOnly
                    />
                  </h5>
                </div>
                <div className="col-2">
                  <BsArrowUpRight className="text-end" />
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
      <div className="border rounded w-100 py-3 mt-4 px-5">
        <div className="combo_card_price">
          <h5>
            <FiArrowRightCircle size="20px" color="#00FF00" /> 2 Assessment
          </h5>
          <h5>
            <FiArrowRightCircle size="20px" color="#00FF00" /> Live+Recorded
            Sessions
          </h5>
          <h5>
            <FiArrowRightCircle size="20px" color="#00FF00" /> One Certificate
          </h5>
          <h2>Program Price: ₹ 3,000</h2>
          <Link className="Program_card_link" to={course.link}>
          <button className="px-4 py-2 bg-dark border rounded text-white">
            Enroll Now
          </button>
          </Link>
        </div>
      </div>
    </div>
  )

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: 'background.paper',
        display: 'flex',
      }}
    >
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ minWidth: 300 }}
      >
        <Tab
          label="HTML/CSS Course"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(0)}
        />
        <Tab
          label="PHP Course"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(1)}
        />
        <Tab
          label="Java Course"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(2)}
        />
        <Tab
          label="Python Course"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(3)}
        />
        <Tab
          label=".Net Course"
          className="border rounded bg-dark text-white fw-bold mx-3 px-5 my-2"
          {...a11yProps(4)}
        />
      </Tabs>
      <Box sx={{ flexGrow: 1 }} className="border rounded mx-2">
        <TabPanel value={value} index={0}>
          <CourseWindow course={courses[0]} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CourseWindow course={courses[1]} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <CourseWindow course={courses[2]} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <CourseWindow course={courses[3]} />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <CourseWindow course={courses[4]} />
        </TabPanel>
      </Box>
    </Box>
  )
}
